<template>
  <div></div>
</template>

<script>
import { delParam } from "./../../utils/tools";

export default {
  data() {
    return {
      kpi_user_id: localStorage.getItem("kpi_user_id") || 0,
      share_user_id: localStorage.getItem("share_user_id") || 0,
      act_id: localStorage.getItem("act_id") || 0,
      inviteId: localStorage.getItem("inviteId") || 0,
      shop_id: localStorage.getItem("shop_id") || 0,
      brand_id: localStorage.getItem("brand_id") || 0,
      referer: localStorage.getItem("referer"),
    };
  },
  created() {
    this.redirectPage();
    this.oAuthWechat();
  },

  methods: {
    async oAuthWechat() {
      if (!this.$utils.isWechat()) {
        this.$toast("请在微信中打开");
        return false;
      }
      const code = this.$route.query.code;

      if (!code) {
        let config = await this.getWXConfig();
        let state = {};
        state.kpi_user_id = localStorage.getItem("kpi_user_id");
        const redirectUri = encodeURIComponent(location.href);
        let oAuthUrl = "https://open.weixin.qq.com/connect/oauth2/authorize";
        oAuthUrl += "?appid=" + config.data.appId;
        oAuthUrl += "&redirect_uri=" + redirectUri;
        oAuthUrl += "&response_type=code";
        oAuthUrl += "&scope=" + config.data.oauth_scope;
        oAuthUrl +=
          "&state=" +
          encodeURI(window.btoa(JSON.stringify(state))) +
          "#wechat_redirect";

        location.href = oAuthUrl;
      } else {
        setTimeout(() => {
          this.getWechatUser(code);
        }, 200);
      }
    },
    async getWechatUser(code) {
      const toPath = localStorage.getItem("toPath");

      if (toPath.indexOf("kpi") === -1) {
        const json = {
          code,
          actId: this.act_id || 0,
          kpiUserId: this.kpi_user_id || 0,
          shareUserId: this.share_user_id || 0,
        };
        let res = await this.$http.post("/v1/wechat/login", json);
        if (res.code === 20302) {
          console.log("code重复");
          return this.$router.push({
            path: "/login",
          });
        }
        if (res.code === 0) {
          localStorage.setItem("token", res.data.wxToken);
          localStorage.setItem("userName", res.data.nickname);
          localStorage.setItem("avatarUrl", res.data.avatar);
          localStorage.setItem("openid", res.data.openid);
          localStorage.setItem("user_id", res.data.userId);
          localStorage.setItem("share_user_id", res.data.shareUserId || 0);
          if (res.data.userType === "cus") {
            // 【活动客户】客户自己的usertype，应该为cus
            localStorage.setItem("userType", res.data.userType);
            //【活动客户】邀请其进入的kpi用户Id
            localStorage.setItem("kpi_user_id", res.data.inviteKpiUserId);
            //【活动客户】邀请其进入的kpi用户-品牌id
            localStorage.setItem("brand_id", res.data.inviteBrandId);
            //【活动客户】邀请其进入的kpi用户-店铺id
            localStorage.setItem("shop_id", res.data.inviteShopId);
          } else {
            localStorage.setItem("userType", res.data.kpiUserType);
            localStorage.setItem("kpi_user_id", res.data.kpiUserId);
            localStorage.setItem("brand_id", res.data.brandId);
            localStorage.setItem("shop_id", res.data.shopId);
          }
          this.redirectPage(toPath);
        }
      } else {
        let kpiUserType = "";
        if (toPath === "/staffRegister") {
          kpiUserType = "staff";
        } else if (toPath === "/managersRegister") {
          kpiUserType = "brand";
        } else if (toPath === "/activityRegister") {
          kpiUserType = "act";
        }
        const json = {
          code,
          actId: localStorage.getItem("act_id") || 0,
          inviteId: this.inviteId || 0,
          kpiUserType,
        };
        let res = await this.$http.post("/v1/wechat/register", json);
        if (res.code === 0) {
          localStorage.setItem("share_user_id", res.data.shareUserId || 0);
          localStorage.setItem("inviteId", res.data.inviteId || 0);
          localStorage.setItem("kpiUserStatus", res.data.kpiUserStatus);
          localStorage.setItem("kpi_user_id", res.data.kpiUserId);
          localStorage.setItem("user_id", res.data.userId); //注册提交用的微信用户Id
          localStorage.setItem("kpiRealName", res.data.kpiUserName); //KPI用户名的注册姓名
          localStorage.setItem("kpiUserMobile", res.data.kpiUserMobile); //KPI用户名的注册手机
          localStorage.setItem("userType", res.data.kpiUserType);
          localStorage.setItem("userName", res.data.nickname);
          localStorage.setItem("userMobile", res.data.mobile);
          localStorage.setItem("brandId", res.data.brandId);
          localStorage.setItem("avatarUrl", res.data.avatar);
          this.redirectPage(toPath);
        }
      }
    },
    redirectPage(toPath) {
      let tmp = localStorage.getItem("preheatPath") || "prehddd";

      if (!localStorage.getItem("token")) {
        return;
      }

      const redirectUrl = this.referer
        ? { path: this.referer }
        : toPath  
        ? { path: toPath }
        : { path: tmp };

      setTimeout(() => {
        // location.href = location.origin + '/' + location.hashhash
        console.log(this.act_id,redirectUrl);
        localStorage.removeItem("referer");
        if(toPath){
          // 跳转pre时强制a标签跳转
          var newurl = this.referer? this.referer : toPath  ?  toPath : tmp ;
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = location.origin + newurl;
          document.body.appendChild(link);
          link.click();
        }else{
          this.$router.push(redirectUrl);
        }
      }, 500);
    },
    async getWXConfig() {
      return await this.$http.get("/v1/wechat/config/get");
    },
    getValue(url, variable) {
      var query = url.split("?").slice(1).join("");
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return 0;
    },
  },
};
</script>

<style>
</style>